









































































import Vue from "vue";
import Component from "vue-class-component";
import { Prop, Watch } from "vue-property-decorator";
import { Language } from "../../services/language/entities/language.interface";
import { Page } from "../../services/settings/entities/page.interface";
import constants from "../../config/constants";

@Component
export default class SideBar extends Vue {
  @Prop() drawer!: boolean;
  readyOpen = false;
  loadingLanguage = false;

  private getTermsByIso(iso: string): void {
    this.loadingLanguage = true;
    this.$store.dispatch("language/getPreferredLanguage", iso).finally(() => {
      this.loadingLanguage = false;
    });
  }

  @Watch("drawer")
  private openSidebar(): void {
    this.readyOpen = !this.readyOpen;
  }

  private created(): void {
    const lang = localStorage.getItem("lang");
    this.$store.dispatch("language/getLanguages");
    this.$store.dispatch(
      "language/getPreferredLanguage",
      lang !== null ? lang : process.env.VUE_APP_LANGUAGE_BASE
    );
  }

  private goToOption(url: string): void {
    this.$router.currentRoute.path != url ? this.$router.push(url) : false;
  }
  openTab(url: string) {
    window.open(url);
  }
  private serCurrentOption(path: string): string {
    if (path == this.$route.path) {
      return "blue";
    } else {
      if (`${path}/${this.$route.params.id}` == this.$route.path) {
        return "blue";
      } else {
        return "black";
      }
    }
  }

  private get preferredLanguage(): string {
    return this.$store.getters["language/getPreferredLanguage"];
  }

  private get languages(): Array<Language> {
    return this.$store.getters["language/getLanguages"];
  }

  private get pages(): Array<Page> {
    const pages = this.$store.getters["settings/getPages"];
    const result = pages.filter(
      (page: Page) => page.pageStatus == constants.STATUS.ACTIVE
    );

    return result;
  }
  get customPages(): Array<Page> {
    const pages = this.$store.getters["settings/getCustomPages"];
    const result = pages.filter(
      (page: Page) => page.pageStatus == constants.STATUS.ACTIVE
    );

    return result;
  }
  private beforeCreate(): void {
    this.$store.dispatch("settings/getPages").then(() => {
      const result = this.$store.getters["settings/getPages"].filter(
        (page: Page) => page.pageStatus == constants.STATUS.INACTIVE
      );
      let active = true;

      for (let index = 0; index < result.length; index++) {
        if (result[index].pagePath == this.$route.path) {
          active = false;
        }
      }

      if (!active) {
        this.$router.push("/not-found");
      }
    });
  }
}
